<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "CompanyAccess",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  